import { CountryAssessments, HIHAssessmentResponseByContinent } from "@app/features/other/genericApiSlice";
import CountryCard from "./CountryCard";

type CountriesListProps = {
  groupedCountries: HIHAssessmentResponseByContinent[];
  handleCountryClick: (country: CountryAssessments) => void;
};

const CountriesList = ({ groupedCountries, handleCountryClick }: CountriesListProps) => {
  return (
    <div className="countries-container">
      {groupedCountries.map(({ name, countries }, index) => (
        <div className="continent-group" key={`${name}-${index}`}>
          <h2 className="continent-title">{name}</h2>
          <div className="countries-grid">
            {countries.map((country) => (
              <CountryCard
                key={country.iso_code}
                country={country}
                handleCountryClick={handleCountryClick}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CountriesList;
